// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const larvesta: PokeData = {
  "id": 636,
  "name": "larvesta",
  "height": 11,
  "weight": 288,
  "base_experience": 72,
  "types": [
    PokeType.BUG,
    PokeType.FIRE
  ],
  "api_moves": [
    "take-down",
    "thrash",
    "double-edge",
    "ember",
    "absorb",
    "string-shot",
    "screech",
    "amnesia",
    "leech-life",
    "flame-wheel",
    "flare-blitz",
    "bug-buzz",
    "bug-bite",
    "flame-charge",
    "struggle-bug"
  ],
  "moves": [
    "ember",
    "string-shot",
    "flare-blitz",
    "bug-buzz",
    "bug-bite",
    "blaze-kick",
    "fire-ball",
    "signal-spam",
    "eruption",
    "fire-punch",
    "morning-sun",
    "lunge",
    "fire-spin"
  ],
  "evolution_chain": {
    "id": 324,
    "item": null,
    "species": [
      {
        "name": "larvesta",
        "order": 637,
        "types": [
          PokeType.BUG,
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "volcarona",
        "order": 638,
        "types": [
          PokeType.BUG,
          PokeType.FIRE
        ],
        "evolves_from_species_id": 636,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 59,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 55,
    "speed": 60,
    "ability_power": 85
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
